import { IAsset } from '@imcc/transport';
import { TagManagerProductDto } from './tag-manager-product.dto';

export function buildOtherProduct(asset: IAsset): TagManagerProductDto {
  return Object.assign(new TagManagerProductDto(), {
    id: asset.id,
    name: `${asset.name}.${asset.fileExtension}`,
  });
}
